
export class StateRecord {
    id?: number;
    siteId: number;
    /** UUID of the entity the state item belongs to. */
    item: string;
    /** E.g: AutoFilterVersion, PowerState etc. */
    name: string;
    /** The actual value of the state item. */
    state: string;
    /** ISO timestamp */
    updated: string;
    device?: string;

    constructor(data:Partial<StateRecord>={}) {
        Object.assign(this, data);
    }
}